var _style, _g, _rect, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x37_09-plus_x40_2x.png_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "-156 247 299 300",
    style: {
      enableBackground: "new -156 247 299 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F8CF0D;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{font-family:'Arial';}\r\n\t.st4{font-size:91.0022px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x37_46-plus-circle_x40_2x.png_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -5.6,
    cy: 397.1,
    r: 146
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -66,
    y: 334,
    className: "st1",
    width: 132,
    height: 152
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2676 0 0 1 -77 427.2305)",
    className: "st2 st3 st4"
  }, "K3")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK3);
export default __webpack_public_path__ + "static/media/k3.6ec76ba10ee5e50b8dc8131b1dcf1c3f.svg";
export { ForwardRef as ReactComponent };